module.exports = __webpack_public_path__ + "static/media/icon-three.48b1fb35.webp";